export default __webpack_public_path__ + "static/media/Cow-moo-sound.0341721b.mp3";